import { render, staticRenderFns } from "./OwnerAccountingSummaryTab.vue?vue&type=template&id=2bcfbf9a&"
import script from "./OwnerAccountingSummaryTab.vue?vue&type=script&lang=js&"
export * from "./OwnerAccountingSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports